export enum DOCUMENT_CENTER_ASSET_KEYS {
  LEFT_ARROW = 'LEFT_ARROW',
  ATTENTION_ICON = 'ATTENTION_ICON',
  HEADER_IMAGE = 'HEADER_IMAGE',
  RIGHT_CHEV_GRAY = 'RIGHT_CHEV_GRAY',
  EOB_ICON = 'EOB_ICON',
  NO_DOCS = 'NO_DOCS',
  RIGHT_INDICATOR = 'RIGHT_INDICATOR',
}

export type DocumentCenterAssets = Record<DOCUMENT_CENTER_ASSET_KEYS, unknown>;
